import { useSnackbar } from 'notistack'
import { useContext, useState } from 'react'
import { FieldErrors } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AddEditDomainContext } from 'features/inventory/domain/contexts/AddEditDomainContext'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { mapGraphQLErrors } from 'providers/tanstack-query/utils'
import { Schema } from '../../schema'
import { mapper } from './api/mapper'
import { UPDATE_DOMAIN_PREBID_STACK } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseUpdateDomainPrebidStack } from './types'

export const useUpdateDomainPrebidStack = (): UseUpdateDomainPrebidStack => {
  const { t } = useTranslation('features/domain')
  const { enqueueSnackbar } = useSnackbar()
  const { setLoading } = useContext(AddEditDomainContext)
  const [errors, setErrors] = useState<FieldErrors<Schema>>({})

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_DOMAIN_PREBID_STACK,
    onCompleted: async data => {
      const {
        updateDomainPrebidStack: { errors },
      } = data

      setLoading(false)

      if (errors && errors.length > 0) {
        setErrors(mapGraphQLErrors(errors))
        enqueueSnackbar(t('form.error.update'), { variant: 'error' })
      } else {
        setErrors({})
        enqueueSnackbar(t('form.success.update'), { variant: 'success' })
      }
    },
    queriesToInvalidate: ['domain'],
  })

  const update = (data: Schema): void => {
    setLoading(true)

    mutateAsync({
      input: mapper(data),
    })
  }

  return { errors, update }
}
